import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const customerService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/customer/paginate', {
      params,
    })
    return response.data
  },
  fetchAllVerificationCustomer: async (params = {}) => {
    const response = await axiosInstance.get('/customer/verification', {
      params,
    })
    return response.data
  },
  getById: async (id) => {
    const response = await axiosInstance.get('/customer/' + id)
    return response.data
  },
  getVerificationById: async (id) => {
    const response = await axiosInstance.get('/customer/verification/' + id)
    return response.data
  },
  updateVerification: async (id, params) => {
    const response = await axiosInstance.put('/customer/verification/' + id, params)
    return response.data
  },
  findByNomenForRedeem: async (nomen) => {
    const response = await axiosInstance.get('/customer/nomen/' + nomen)
    return response.data
  },
  sendOtp: async (nomen) => {
    const response = await axiosInstance.post('/customer/reward/otp/send', { nomen })
    return response.data
  },
  resend: async (nomen) => {
    const response = await axiosInstance.post('/customer/reward/otp/resend', { nomen })
    return response.data
  },
  redeemReward: async ({ rewardId, otp, rewardNote }) => {
    const response = await axiosInstance.post('/customer/reward/redeem', { rewardId, otp, rewardNote })
    return response.data
  },
  cancelRedeem: async (nomen) => {
    const response = await axiosInstance.post('/customer/reward/reset/', { nomen })
    return response.data
  },
}
